import { all, call, fork, put, takeLatest } from "redux-saga/effects";

import moment from "moment";

import { Creators as ActionsProtocolos, Types } from "ducks/Protocolos";
import { Creators as ActionsGeral } from "ducks/Geral";

import api from "../api/api";
import notify from 'utils/modern_notify';

let mensagem = {};

const requisicaoenviaNotaFisico = async (notaHabilitarFisico) =>
    api
        .put(`api/protocolos/nota/atualizastatus`, notaHabilitarFisico)
        .then((notaHabilitarFisico) => notaHabilitarFisico)
        .catch((error) => error);

const buscarRomProtReq = async (dados) =>
    api
        .post(`api/protocolos/buscar/romaneio`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const enviarRomPreviaProtReq = async (dados) =>
    api
        .post(`api/protocolos/previa`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const reqGerarProtocolo = async (dados) =>
    api
        .post(`api/protocolos/acao`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const fimProtolosReq = async (dados) =>
    api
        .put(`api/protocolos/cancelar`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const pesquisarProtocolosReq = async (dados) =>
    api
        .post(`api/protocolos/buscar/protocolo`, dados)
        .then((dados) => dados)
        .catch((error) => error);

const buscarNotasProReq = async (dados) =>
    api
        .post(`api/protocolos/buscar/impressao`, dados)
        .then((dados) => dados)
        .catch((error) => error);

function* getImagemCanhoto({ payload }) {
    const { canhotos } = payload;

    yield put(ActionsProtocolos.getImagemCanhotoSucesso(canhotos));
}

function* buscarNtPro({ payload }) {
    const dados = payload;

    try {
        const response = yield call(buscarNotasProReq, dados);
        if (response.ok === true) {
            yield put(
                ActionsProtocolos.buscarNtProSucesso(response.data.valor)
            );
        } else {
            // yield put(
            //     ActionsGeral.setMensagem({
            //         mensagem: `Erro Buscar Notas: ${response.data.erro.erro}`,
            //         mostrar: true,
            //     })
            // );
            notify(`Erro Buscar Notas: ${response.data.erro.erro}`)
            
        }
    } catch (error) {}
}

function* pesquisarProtocolos({ payload }) {
    const {
        startDate,
        endDate,
        protocolo,
        cnpj_empresa,
        bases,
        cpfUsuario,
    } = payload;

    let filtros = {
        numero_protocolo: protocolo,
        cnpj_empresa,
        bases,
        cpfUsuario,
    };

    if (startDate) {
        filtros = {
            ...filtros,
            dataInicio: moment(startDate).format("DDMMYYYY"),
            dataFim: moment(endDate).format("DDMMYYYY"),
        };
    }

    try {
        const response = yield call(pesquisarProtocolosReq, filtros);
        if (response.ok) {
            if (response.data.resultado === true) {
                if (Object.keys(response.data.valor).length > 0) {
                    yield put(ActionsProtocolos.setLoadPesqProt(false));
                    yield put(
                        ActionsProtocolos.pesquisarProtocolosSucesso(
                            response.data.valor
                        )
                    );
                } else {

                    notify(`Nenhum protocolo encontrado.`,1)
                }
            } else {
                notify(`Erro ao fazer pesquisa: ${response.data.erro.erro}`)
            }
        } else if (
            Object.prototype.hasOwnProperty.call(response.data, "error")
        ) {
            if (response.data.resultado === false) {
                mensagem =
                    ("Ocorreu um erro ao enviar informações",
                    response.data.resultado.error);
            }
        } else {
            mensagem = "Ocorreu um erro interno. Tente novamente";
        }

        yield put(ActionsProtocolos.setLoadPesqProt(false));
    } catch (error) {
        yield put(ActionsProtocolos.setLoadPesqProt(false));
        notify(`Erro ao enviar informações: ${error}`)
    }
}

function* enviarNotaFisico({ payload }) {
    const { notaHabilitarFisico } = payload;

    try {
        const response = yield call(
            requisicaoenviaNotaFisico,
            notaHabilitarFisico
        );
        if (response.ok) {
            if (response.data.resultado === true) {
                notify(`Nota enviada.`,2)
                yield put(
                    ActionsProtocolos.enviarNotaFisicoSucesso(
                        notaHabilitarFisico
                    )
                );
                yield put(ActionsProtocolos.setLoadFis(false));
            } else {
                notify(`Erro ao enviar nota: ${response.data.erro.erro}`)
            }
        } else if (
            Object.prototype.hasOwnProperty.call(response.data, "error")
        ) {
            yield put(ActionsProtocolos.setLoadFis(false));
            yield put(ActionsProtocolos.enviarNotaFisicoSucesso([]));

            if (response.data.resultado === false) {
                mensagem =
                    ("Ocorreu um erro ao enviar informações",
                    response.data.resultado.error);
            }
        } else {
            mensagem = "Ocorreu um erro interno. Tente novamente";
        }
    } catch (error) {
        yield put(ActionsProtocolos.setLoadFis(false));
        yield put(ActionsProtocolos.enviarNotaFisicoSucesso([]));
        notify(`Erro ao enviar informações: ${error}`)
    }
}
function* fimProtolos({ payload }) {
    const { dados } = payload;

    try {
        const response = yield call(fimProtolosReq, dados);
        if (response.ok) {
            if (response.data.resultado === true) {
                notify(`Processo de geração de protocolos finalizado com sucesso !`,2)

                yield put(ActionsProtocolos.setListaRomProtSele([]));
                yield put(ActionsProtocolos.buscarRomProtSucesso([]));
                yield put(ActionsProtocolos.setCardsProt([]));
            } else {
                notify(`Erro ao finalizar processo protocolos: ${response.data.erro.erro}`)
            }
        } else if (
            Object.prototype.hasOwnProperty.call(response.data, "error")
        ) {
            if (response.data.resultado === false) {
                mensagem =
                    ("Ocorreu um erro ao enviar informações",
                    response.data.resultado.error);
            }
        } else {
            mensagem =
                "Ocorreu um erro interno ao finalizar processo protocolos. Tente novamente";
        }
    } catch (error) {
        notify(`Erro ao finalizar processo protocolos: ${error}`)
    }
}

function* buscarRomProt({ payload }) {
    const {
        datas,
        romaneio,
        cnpjEmpresa,
        exibirtodos,
        bases,
        nomeUsuario,
        cpfUsuario,
    } = payload;

    let dados = [];

    mensagem = "";

    let obj = {
        numero_romaneio: romaneio,
        cnpj_empresa: cnpjEmpresa,
        exibirtodos,
        nomeUsuario,
        cpfUsuario,
        bases,
    };

    if (datas.startDate) {
        obj = {
            ...obj,
            dataInicio: moment(datas.startDate).format("DDMMYYYY"),
            dataFim: moment(datas.endDate).format("DDMMYYYY"),
        };
    }

    try {
        const response = yield call(buscarRomProtReq, obj);
        if (response.ok) {
            if (response.data.resultado) {
                response.data.valor.forEach((romaneio) => dados.push(romaneio));

                yield put(ActionsProtocolos.buscarRomProtSucesso(dados));
                yield put(ActionsProtocolos.setLoadBuscRom(false));
            } else {
                notify("Não foi possível buscar romaneios.")
                yield put(ActionsProtocolos.setLoadBuscRom(false));
                yield put(ActionsProtocolos.buscarRomProtSucesso([]));
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagem = "Ocorreu um erro interno.Tente novamente";
            }
            notify(mensagem)
            yield put(ActionsProtocolos.setLoadBuscRom(false));
        }
    } catch (error) {
        yield put(ActionsProtocolos.setLoadBuscRom(false));
        notify(`Erro: ${error}`)
        yield put(ActionsProtocolos.buscarRomProtSucesso([]));
    }
}

function* enviarRomPreviaProt({ payload }) {
    const {
        cnpjEmpresa,
        tipoEmpresa,
        idUnidade,
        idUsuario,
        romaneios,
        cpfUsuario,
        nomeUsuario,
    } = payload;

    let dados = [];

    mensagem = "";

    const obj = {
        cnpj_empresa: cnpjEmpresa,
        tipoEmpresa,
        cpfUsuario,
        nomeUsuario,
        idUnidade,
        idUsuario,
        romaneios,
    };

    if (obj.romaneios.length === 0) {
        notify(`Por favor, selecione pelo menos um romaneio para visualizar protocolo.`,1)
    } else {
        try {
            const response = yield call(enviarRomPreviaProtReq, obj);
            if (response.ok) {
                if (response.data.resultado) {
                    dados = response.data.valor;
                    yield put(
                        ActionsProtocolos.enviarRomPreviaProtSucesso(dados)
                    );
                    yield put(ActionsProtocolos.setLoadBuscPrevProt(false));
                    yield put(ActionsProtocolos.buscarRomProtSucesso([]));
                } else {
                    notify(response.data.erro)
                    yield put(ActionsProtocolos.enviarRomPreviaProtSucesso([]));
                }
            } else {
                if (
                    Object.prototype.hasOwnProperty.call(response.data, "error")
                ) {
                    switch (response.data.error) {
                        default:
                            mensagem = `Ocorreu um erro${response.data.error}`;
                            break;
                    }
                } else {
                    mensagem = "Ocorreu um erro interno.Tente novamente";
                }
                notify(mensagem)
                yield put(ActionsProtocolos.setLoadBuscPrevProt(false));
                yield put(ActionsProtocolos.enviarRomPreviaProtSucesso([]));
            }
            yield put(ActionsProtocolos.setLoadBuscPrevProt(false));
        } catch (error) {
            yield put(ActionsProtocolos.setLoadBuscPrevProt(false));
            yield put(ActionsProtocolos.enviarRomPreviaProtSucesso([]));
            notify(`Erro: ${error}`)
        }
    }
}

function* gerarProtocolo({ payload }) {
    const { protocolo } = payload.gerar;

    let index = 0;
    let response = {};
    let resposta = [];
    let respostas = [];
    let protocolos = [];
    let porcen = 0;

    if (protocolo.length === 0) {
        notify(`Não há protocolos selecionados.`,1)
    }

    let totalNotas = 0;

    protocolo.forEach((p) => (totalNotas += Object.keys(p.notas).length));

    try {
        while (index < protocolo.length) {
            let prot = protocolo[index];

            prot.index = index;
            protocolos.push(protocolo[index]);
            porcen += Math.round(
                (Object.keys(prot.notas).length / totalNotas) * 100
            );

            yield put(
                ActionsProtocolos.setGerarProtLoad({
                    exibir: true,
                    criando: true,
                    prot,
                    porcen,
                    total: protocolo.length,
                })
            );
            try {
                response = yield call(reqGerarProtocolo, { protocolos });
                if (response.ok) {
                    if (response.data.resultado === true) {
                        resposta = response.data.valor;
                        respostas.push(response.data.valor);

                        yield put(
                            ActionsProtocolos.gerarProtocoloSucesso(resposta)
                        );
                    } else {
                        notify(`Erro ao criar protocolo: ${response.data.erro.erro}`)
                    }
                } else {
                    if (response.problem) {
                        notify(`Solicitação não concluida, ocorreu um erro no servidor: ${response.problem}: ${response.status}`)
                    } else {
                        notify(`Ocorreu um erro no servidor`)
                    }
                }
            } catch (error) {
                notify(`Erro ao enviar informações: ${error}`)
            }

            protocolos = [];
            index++;
        }

        yield put(
            ActionsProtocolos.setGerarProtLoad({
                exibir: false,
                criando: false,
                prot: {},
                porcen: 0,
                total: 0,
            })
        );

        if (protocolo.length === respostas.length) {
            notify(`Protocolo criado com sucesso.`,2)
        }
    } catch (error) {
        notify(`Erro ao processar: ${error}`)
    }
}

function* imprimirProtocolo({ payload }) {
    const { imprimir } = payload;

    yield put(ActionsProtocolos.imprimirProtocoloSucesso(imprimir));
}

function* exportarProtocolo({ payload }) {
    const { exportar } = payload;

    yield put(ActionsProtocolos.exportarProtocoloSucesso(exportar));
}

export function* exportarProtocoloAcao() {
    yield takeLatest(Types.EXPORTAR_PROTOCOLO, exportarProtocolo);
}

export function* pesquisarProtocolosAcao() {
    yield takeLatest(Types.PESQUISAR_PROTOCOLOS, pesquisarProtocolos);
}

export function* buscarRomProtAcao() {
    yield takeLatest(Types.BUSCAR_ROM_PROT, buscarRomProt);
}

export function* enviaNotaFisicoAcao() {
    yield takeLatest(Types.ENVIAR_NOTA_FISICO, enviarNotaFisico);
}

export function* enviarRomPreviaProtAcao() {
    yield takeLatest(Types.ENVIAR_ROM_PREVIA_PROT, enviarRomPreviaProt);
}

export function* gerarProtocoloAcao() {
    yield takeLatest(Types.GERAR_PROTOCOLO, gerarProtocolo);
}

export function* imprimirProtocoloAcao() {
    yield takeLatest(Types.IMPRIMIR_PROTOCOLO, imprimirProtocolo);
}
export function* fimProtolosAcao() {
    yield takeLatest(Types.FIM_PROTOCOLOS, fimProtolos);
}

export function* getImagemCanhotoAcao() {
    yield takeLatest(Types.GET_IMAGEM_CANHOTO, getImagemCanhoto);
}

export function* buscarNtProAcao() {
    yield takeLatest(Types.BUSCAR_NT_PRO, buscarNtPro);
}

export default function* rootSaga() {
    yield all([
        fork(enviaNotaFisicoAcao),
        fork(buscarRomProtAcao),
        fork(enviarRomPreviaProtAcao),
        fork(gerarProtocoloAcao),
        fork(fimProtolosAcao),
        fork(imprimirProtocoloAcao),
        fork(pesquisarProtocolosAcao),
        fork(exportarProtocoloAcao),
        fork(getImagemCanhotoAcao),
        fork(buscarNtProAcao),
    ]);
}
